import { Markdown as MarkdownBase, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.div<{ $active: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border-bottom: 1px solid var(--border-soft);
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: var(--surface-active);
  }

  &:first-child:hover {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &:last-child:hover {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  ${({ $active }) =>
    $active &&
    `
    background: var(--surface-active);
    `}
`;

export const MarkdownWrapper = styled.div<{ $condensed?: boolean }>`
  ${typographyV2.bodySm};

  ${MarkdownBase.Styled.MarkdownStyles} {
    margin-bottom: 0;

    p {
      margin-bottom: 0;
    }
  }
`;

export const StyledLabel = styled.span`
  word-wrap: break-word;
  overflow-wrap: break-word;
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;
